<template>
  <div id="ColocationDetailSummary" class="detailContainer">
    <div class="contentSummary">
      <span
        class="material-icons closeOrder"
        @click="cancelOrder()"
        v-if="false"
        >close</span
      >
      <div :class="{ padding60: !IsMobile }">
        <div class="mdl-grid">
          <div class="mdl-cell mdl-cell--12-col">
            <MyHeaderPage
              :title="$t('colocation.titleDetails')"
              :calendar="true"
            />
          </div>
        </div>

        <div class="infoKit orange padding-vertical">
          <div class="mdl-grid">
            <div
              class="mdl-cell mdl-cell--5-col mdl-cell--12-col-tablet mdl-cell--12-col-phone"
            >
              <div class="mdl-cell mdl-cell--12-col">
                <div class="summaryItem">
                  <div class="contentImage">
                    <img
                      src="@/assets/img/icon_pin.png"
                      alt="location"
                      width="45"
                    />
                  </div>
                  <div>
                    <div>
                      <span class="labelOne">{{
                        $t("colocation.detail.dc")
                      }}</span>
                    </div>
                    <div>
                      <span class="textOne">
                        {{ rack.room }} {{ rack.address }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="mdl-cell mdl-cell--12-col">
                <hr />
              </div>
              <div class="margin-top-20"></div>
              <div class="mdl-cell mdl-cell--12-col">
                <div
                  class="mdl-grid flex-center-between"
                >
                  <div class="mdl-cell--col-10">
                    <span class="detailOne">
                      <img
                        src="@/assets/img/icon_info.png"
                        alt="icon"
                        width="43"
                      />{{ $t("colocation.detail.rack") }}</span
                    >
                  </div>

                  <div class="mdl-cell--col-2">
                    <span class="detailThree">{{ rack.name }}</span>
                  </div>
                </div>
              </div>
              <div class="mdl-cell mdl-cell--12-col">
                <hr />
              </div>
              <div class="mdl-cell mdl-cell--12-col">
                <div
                  class="mdl-grid flex-center-between"
                >
                  <div class="mdl-cell--col-10">
                    <span class="detailOne">
                      <img
                        src="@/assets/img/icon_info.png"
                        alt="icon"
                        width="43"
                      />{{ $t("colocation.detail.isle") }}</span
                    >
                  </div>

                  <div class="mdl-cell--col-2">
                    <span class="detailThree">{{ rack.isle }}</span>
                  </div>
                </div>
              </div>
              <div class="mdl-cell mdl-cell--12-col">
                <hr />
              </div>
              <div class="mdl-cell mdl-cell--12-col">
                <div
                  class="mdl-grid flex-center-between"
                >
                  <div class="mdl-cell--col-10">
                    <span class="detailOne"
                      ><img
                        src="@/assets/img/icon_info.png"
                        alt="icon"
                        width="43"
                      />{{ $t("colocation.detail.floor") }}</span
                    >
                  </div>

                  <div class="text-right">
                    <span class="detailThree">{{
                      rack.floor ? rack.floor : "-"
                    }}</span>
                  </div>
                </div>
              </div>
              <div class="mdl-cell mdl-cell--12-col">
                <hr />
              </div>
            </div>
            <div class="mdl-cell mdl-cell--2-col margin-top-70"></div>
            <div
              class="mdl-cell mdl-cell--5-col mdl-cell--12-col-tablet mdl-cell--12-col-phone margin-top-70"
            >
              <div class="mdl-cell mdl-cell--12-col">
                <div
                  class="mdl-grid flex-center-between"
                >
                  <div class="mdl-cell--col-10">
                    <span class="detailOne"
                      ><img
                        src="@/assets/img/icon_info.png"
                        alt="icon"
                        width="43"
                      />{{ $t("colocation.detail.type") }}</span
                    >
                  </div>

                  <div class="text-right">
                    <span class="detailThree">{{ rack.type }}</span>
                  </div>
                </div>
              </div>
              <div class="mdl-cell mdl-cell--12-col">
                <hr />
              </div>
              <div class="mdl-cell mdl-cell--12-col">
                <div
                  class="mdl-grid flex-center-between"
                >
                  <div class="mdl-cell--col-10">
                    <span class="detailOne"
                      ><img
                        src="@/assets/img/icon_info.png"
                        alt="icon"
                        width="43"
                      />{{ $t("colocation.detail.shared") }}</span
                    >
                  </div>

                  <div class="text-right">
                    <span class="detailThree">{{
                      rack.shared == false ? "NO" : $t("colocation.yes")
                    }}</span>
                  </div>
                </div>
              </div>
              <div class="mdl-cell mdl-cell--12-col margin-top-25">
                <hr />
              </div>
            </div>
          </div>
        </div>

        <div>
          <div
            class="contentButton content-button-center"
          >
            <router-link :to="'/colocation'">
              <button class="cdlButton">
                {{ $t("colocation.backToList") }}
              </button>
            </router-link>
          </div>
        </div>
      </div>

      <MyLoading :viewLoader="viewSubmit" type="" />
      <StatusAlert v-if="viewError" status="error" role="alert">
        <template #body>
          <p v-html="$t('checkCoverageSummary.errorGeneric')"></p>
        </template>
      </StatusAlert>
    </div>
  </div>
</template>

<script>
import MyLoading from "@/components/MyLoading.vue";
import MyHeaderPage from "@/components/MyHeaderPage.vue";
import StatusAlert from "@/components/Primitives/Alerts/StatusAlert.vue";
import "@/assets/scss/Solutions.scss";
import "@/assets/scss/LinesDetailSummary.scss";

export default {
  name: "ColocationDetail",
  components: {
    MyHeaderPage,
    MyLoading,
    StatusAlert,
  },
  data() {
    return {
      rack: {},
      viewModal: false,
      viewSubmit: true,
      viewError: false,
      IsMobile: this.$IsMobile(),
    };
  },
  methods: {
    getEntity(entityId) {
      let he = {
        Accept: "application/json",
        Authorization: "Bearer " + this.$keycloak.idToken,
      };
      if (entityId) {
        this.axios
          .get(
            `${window.VUE_APP_MISTRA_URL}assets/v1/colocation/${entityId}`,
            { headers: he }
          )
          .then((response) => {
            if (response.data.length) {
              this.rack = response.data[0];
            }
          })
          .catch(function (err) {
            self.viewSubmit = true;
            self.viewError = true;
            self.messageError = err.response.data.message;
            setTimeout(() => {
              self.viewError = false;
            }, 5000);
          });
      }
    },
  },
  mounted() {
    window.scrollTo(0, 0);
    this.getEntity(this.$route.params.id);
  },
  beforeUpdate() {
    this.$IsLoggedIn();
  },
};
</script>
